import { useState } from "react";
import { createNewsLetterAPI } from "../Home-Page/home-page.component.service";
import FooterTemplate from "./footer.template";
import { useSelector } from "react-redux";

const FooterComponent = () => {
  const { settings } = useSelector((state) => state.app);
  const [subscribed, setSubscribed] = useState(false);
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState({ show: false });

const handleSubscribe = async () => {
  if (!email.trim()) {
    console.log("Please enter an email address");
    return;
  }

  const payload = {
    email: email.trim(),
  };

  const response = await createNewsLetterAPI(payload);
  console.log("Subscription response:", response.message);

  if (response.status) {
    setSubscribed(true);
    setEmail("");
    setAlert({
      ...alert,
      show: true,
      type: "success",
      message: "Email subscribed successfully",
    });
  } else {
    setAlert({
      ...alert,
      show: true,
      type: "danger",
      message: response.message,
    });
  }
};

const handleAlertClose = () => {
    setAlert({ ...alert, show: false });
  };

  const templateData = {
    settings,
    subscribed,
    email,
    alert,
  };

  const templateEvent = {
    handleSubscribe,
    setEmail,
    email,
    handleAlertClose,
  };

  return (
    <FooterTemplate 
    templateData={templateData} 
    templateEvent={templateEvent} 
    />
  );
};

export default FooterComponent;
